import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
}), 'ReplyTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReplyTwoTone.js
// module id = 5782
// module chunks = 2